// French
export default {
  newVersionAvailable: 'Nouvelle version disponible',
  versionInfo: 'Une nouvelle version de {appName} est disponible. Veuillez recharger la page pour mettre à jour vers la version {version}.',
  reload: 'Recharger',
  later: 'Plus tard',
};
